import ProviderOrderFormConfig from "./form";
import GenericForm from "../GenericForm";
import { ProviderOrderFormData } from "@/formTypes/ProviderOrderDataType";
import { ProviderOrderApi, ProviderOrderDataType } from "@/api/ProviderOrderApi";
import { useLayoutEffect, useRef, useState } from "react";
import { getDefaultCurrency } from "@utils/Currency";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";
import { flushDocumentProductEdits } from "@utils/eDocumentFlush";
import QuickAddProductForm from "../QuickAddProductForm";
import EdocumentProductList from "@components/dynamic/EdocumentProductList";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { clearDocument, loadProducts } from "@/store/slices/eDocumentSlides";
import { ProviderApi } from "@/api/ProviderApi";
import EdocumentComments from "@components/dynamic/EdocumentComments";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";

type ProviderOrderFormProps = {
  formId: string,
  saveRedirectUrl: string,
  id?: string
  copyData?: boolean
}

const ProviderOrderForm = (props: ProviderOrderFormProps) => {
  const { copyData, id } = props
  const [defaultData, setDefaultData] = useState<ProviderOrderDataType>({});
  const formRef = useRef<DynamicFormRef>(null);
  const documentProducts = useAppSelector(state => state.eDocument.documentProducts);
  const eDocumentComments = useAppSelector(state => state.eDocument.documentComments)
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    resetFormData();
  }, []);

  const resetFormData = async () => {
    formRef.current?.resetFormValue()
    setTimeout(async () => {
      const defaultCurrency = await getDefaultCurrency()
      if (defaultCurrency.id) {
        setDefaultData({ currencyId: defaultCurrency.id })
        CurrencyIdPubSub.publish({ currencyId: defaultCurrency.id, forceUpload: false })
      }
    });
  }

  const saveProviderOrder = async (): Promise<ProviderOrderDataType> => {
    const eDocumentState = flushDocumentProductEdits();
    const documentProductsState = eDocumentState.documentProducts;
    const primaryData = await formRef.current?.getFormData();
    const provider = await ProviderApi.get(primaryData.providerId)
    if (!documentProductsState || documentProductsState?.length == 0) {
      throw new Error("Por favor agregar algun producto a la orden de compra del provedor")
    }

    let orderData: ProviderOrderDataType = {
      ...primaryData,
      comments: eDocumentState.documentComments,
      providerNombre: provider.nombre,
      products: JSON.stringify(documentProductsState)
    }

    const providerOrder = await ProviderOrderApi.createProviderOrder(orderData)

    dispatch(clearDocument())
    resetFormData()
    return providerOrder
  }

  const loadCopyOrder = async (id: string) => {
    const previousOrder = await ProviderOrderApi.get(id)
    try {
      const products: EDocumentProductDataType[] = JSON.parse(`${previousOrder.products}`)
      dispatch(loadProducts(products))
    } catch (err) {
      console.log("unable to load the previous order products")
    }
    return previousOrder;
  }

  return (
    <>
      <GenericForm<ProviderOrderFormData, ProviderOrderDataType>
        ref={formRef}
        id={id}
        copyData={copyData}
        formId={props.formId}
        defaultData={defaultData}
        formConfig={ProviderOrderFormConfig}
        getById={(...arg) => loadCopyOrder(...arg)}
        createFn={() => saveProviderOrder()}
        successMessage="La Orden de compra del Provedor ha sido almacenada correctamente"
        errorMessage="No fue posible almacenar la información de la Orden de compra del provedor"
      >
        <hr />
        <QuickAddProductForm showCost={true} />
        <EdocumentProductList providerDocument={true} hideSelectProduct={true} />
        <EdocumentComments useToggle={false} />
      </GenericForm>
    </>
  )
}

export default ProviderOrderForm;